// Page formats with editable usable / printable area (in mm).
// Defaults follow what the user provided.

export const PAGE_FORMATS = [
  {
    id: "a4",
    label: "A4",
    width_mm: 210,
    height_mm: 297,
    printable_w_mm: 200,
    printable_h_mm: 285,
  },
  {
    id: "a3",
    label: "A3",
    width_mm: 297,
    height_mm: 420,
    printable_w_mm: 287,
    printable_h_mm: 410,
  },
  {
    id: "a3plus",
    label: "A3+",
    width_mm: 320,
    height_mm: 450,
    printable_w_mm: 310,
    printable_h_mm: 440,
  },
];

export const getPageFormat = (id) =>
  PAGE_FORMATS.find((p) => p.id === id) || PAGE_FORMATS[0];

export const DEFAULT_PAGE = {
  id: "a3plus",
  label: "A3+",
  orientation: "portrait", // 'portrait' | 'landscape'
  width_mm: 320,
  height_mm: 450,
  printable_w_mm: 310,
  printable_h_mm: 440,
};

// Apply orientation to a page format, swapping dimensions when landscape.
export const orientedPage = (page) => {
  if (page.orientation === "landscape") {
    return {
      ...page,
      width_mm: page.height_mm,
      height_mm: page.width_mm,
      printable_w_mm: page.printable_h_mm,
      printable_h_mm: page.printable_w_mm,
    };
  }
  return page;
};
